<template>
  <div>
      <van-nav-bar fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" size="19" />
        </div>
        <div slot="title" class="all-title">详情</div>
      </van-nav-bar>
      <div class="details-wrap" v-if="info">
        <div class="details">
          <div class="details-head van-hairline--bottom">
            <div class="head-ds">
              <div class="details-head-left">
                <span v-if="!info.CreateIcon">
                  {{showName(info.CreatedByName)}}
                </span>
                <img class="user-img" v-else :src="info.CreateIcon + '?time =' + new Date().getTime()" alt="">
              </div>
              <div class="details-head-right">
                <div class="details-title">{{info.CreatedByName}}发起的公文</div>
                <div class="details-state">{{info.DocumentStatusName}}</div>
              </div>
            </div>
            <div class="details-head-img">
              <img v-if="info.DocumentStatus === 16"
                   class="no-data-img"
                   src="@/assets/common/approvalStatus/revoke.png" />
            </div>
          </div>
          <div class="details-main van-hairline--bottom">
            <ul>
              <li class="info-item">
                <span class="title">主题</span>
                <span class="content" v-html="info.Title"></span>
              </li>
              <li class="info-item">
                <span class="title">公文种类</span>
                <span class="content">{{info.TypeName}}</span>
              </li>
              <li class="info-item">
                <span class="title">发文机关</span>
                <span class="content">{{info.DocumentAgency}}</span>
              </li>
              <li class="info-item">
                <span class="title">发文字号</span>
                <span class="content">{{info.DocumentNumber}}</span>
              </li>
              <li class="info-item">
                <span class="title">文件内容</span>
                <div class="fileList">
                  <div class="content" v-for="(item, index) in info.DocFileList" :key="index">
                        <div>
                          <i class="iconfont iconimg" v-if="item.FileType === 'SVG' || item.FileType === 'svg' || item.FileType === 'BMP' || item.FileType === 'JPG' || item.FileType === 'JPEG' || item.FileType === 'PNG' || item.FileType === 'GIF' || item.FileType === 'bmp' || item.FileType === 'jpg' || item.FileType === 'jpeg' || item.FileType === 'png' || item.FileType === 'gif'">&#xe705;</i>
                          <i class="iconfont icontext" v-else>&#xe706;</i>
                        </div>
                        <div class="fileL">
                          <div class="fileName">
                            {{item.FileName}}
                          </div>
                          <div class="fileSize">
                      {{item.FileLength / 1024 / 1024>=1?(item.FileLength / 1024 / 1024).toFixed(2)+'MB':(item.FileLength / 1024).toFixed(2)+'KB'}}
                          </div>
                        </div>
                        <div class="fileR">
                          <!-- <van-button plain round size='small' type="info" @click="downLoad(item)">下载</van-button> -->
                          <button class="downBtn" @click="downLoad(item)">下载</button>
                        </div>
                      </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="document-flow">
          <div class="flow-title">公文流转</div>
          <ul class="flow-list">
            <li class="flow-li" v-for="(item, index) in list" :key="index">
              <!-- 发起人 -->
              <div class="launch" v-if="index === 'DocumentInfo'">
                <div class="flow-item-line"></div>
                <div class="flow-li-head">
                    <span v-if="info.CreateIcon === ''">{{showName(item.CreatedByName)}}</span>
                    <img class="user-img" v-else :src="info.CreateIcon + '?time =' + new Date().getTime()" alt="">
                    <!-- <van-icon name="success" color='white' size='0.4em' style="border: 0.03em solid #fff; position:absolute; bottom: 0; right: 0; border-radius: 50%; transform: translate(25%, 25%); background: #47BA32"  /> -->
                    <img class="false_img" :src="trueImgUrl" alt="">
                </div>
                <div class="flow-li-content">
                  <div class="flow-content-head">
                    <div class="flow-content-name" style="font-weight: bold">
                      <span>{{item.CreatedByName}}</span>
                      <span>(发起人)</span>
                    </div>
                    <div class="flow-content-time">
                      {{xy.moment(item.CreatedTime).format('MM.DD HH:mm')}}
                    </div>
                  </div>
                  <div class="flow-content-body" style="color: rgba(0, 0, 0, .65)">
                    {{item.Note}}
                  </div>
                </div>
              </div>
              <!-- 流转 -->
              <div v-if="index === 'NodeList'">
                <div v-for="(x, y) in item" :key="y">
                  <div class="circulation-wrap launch" v-if="x.OrderName === '申请结束'">
                    <div class="flow-item-line" v-if="x.CommentList.length !== 0 || item.length !== y+1 || (item.length === y+1 && x.UserList[0].ApplyEndStatus === 2)"></div>
                    <div class="flow-li-head" v-if=" x.UserList[0].ApplyEndStatus !== 4">
                        <span v-if="x.UserList[0].Icon === ''">{{showName(x.UserList[0].FullName)}}</span>
                        <img class="user-img" v-else :src="x.UserList[0].Icon + '?time =' + new Date().getTime()" alt="">
                        <img class="false_img" :src="trueImgUrl" alt="">
                    </div>
                    <div class="flow-li-head" v-else>
                        <span v-if="x.UserList[0].Icon === ''">{{showName(x.UserList[0].FullName)}}</span>
                        <img class="user-img" v-else :src="x.UserList[0].Icon + '?time =' + new Date().getTime()" alt="">
                        <img class="false_img" :src="falImgUrl" alt="">
                    </div>
                    <div class="flow-li-content">
                      <div class="flow-content-head">
                        <div class="flow-content-name">
                          <span>{{x.UserList[0].FullName}}</span>
                          <span v-if=" x.UserList[0].ApplyEndStatus !== 4">({{x.OrderName}})</span>
                          <span class="refuse" v-else>({{list.DocumentInfo.CreatedByName}}驳回了您的申请)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div  class="circulation-wrap" v-else>
                    <div class="flow-li-head">
                        <span>{{x.OrderName}}</span>
                    </div>
                    <div class="flow-li-content">
                      <div class="flow-item-line" v-if="list && list.DocumentInfo && list.DocumentInfo.DocumentStatus === 4 || y+1 !== item.length || x.CommentList.length !== 0"></div>
                      <div class="flow-content-head">
                        <div class="flow-content-name">
                          <span class="allpep">流转{{x.UserList.length}}人</span>
                          <span class="signpep">{{x.SignedCount}}人已签收</span>
                        </div>
                        <div class="flow-content-time">
                          {{xy.moment(x.SendTime).format('MM.DD HH:mm')}}
                        </div>
                      </div>
                      <div class="maincirculation" v-if="x.UserList.length > 6">
                        <div class="circulation" v-for="(i,j) in (x.UserList || '').slice(0, displayNum)" :key="j">
                          <div class="flow-content-name dtdd">
                            <span class="flow-avatar3" style="display: inline-block;">
                              <span style="font-size: 10px" v-if="i.Icon === ''">{{ showName(i.FullName ) }}</span>
                              <img class="user-img" v-else :src="i.Icon + '?time =' + new Date().getTime()" alt="">
                              <img class="false_img" :src="trueImgUrl" alt="" v-if="i.IsSign">
                            </span>
                            <span class="circulationName">{{i.FullName }}</span>
                          </div>
                        </div>
                        <div class="circulation" @click="moreUser(x.UserList)">
                          <div class="flow-content-name dtdd">
                            <span class="flow-avatar3" style="display: inline-block;">
                                <van-icon name="friends" size='4vw' style="line-height: 6.667vw" />
                            </span>
                            <span class="circulationName">查看全部</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="maincirculation">
                        <div class="circulation" v-for="(i,j) in x.UserList" :key="j">
                          <div class="flow-content-name dtdd">
                            <span class="flow-avatar3" style="display: inline-block;">
                              <span style="font-size: 10px" v-if="i.Icon === ''">{{ showName(i.FullName ) }}</span>
                              <img class="user-img" v-else :src="i.Icon + '?time =' + new Date().getTime()" alt="">
                              <img class="false_img" :src="trueImgUrl" alt="" v-if="i.IsSign">
                            </span>
                            <span class="circulationName">{{i.FullName }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 评论 -->
                  <div class="plList" v-if="x.CommentList.length > 0">
                    <div class="flow-li-content" v-for="(i, j) in (x.CommentList || '').slice(0, plList[y].num)" :key="j">
                      <div>
                        <div class="flow-li-spot"></div>
                        <div class="flow-item-line" v-if="y+1 !== item.length || x.UserList[0].ApplyEndStatus === 2 || (y+1 === item.length && ((j+1 !== x.CommentList.length && j!== 1) || (j===1 && plList[y].close && x.CommentList.length>2)))"></div>
                        <div class="flow-content-header">
                          <span class="flow-content-name">
                            <span style="color: #4196FF">{{i.FullName}}</span> 添加了评论
                          </span>
                          <span class="flow-content-time openOrback" v-if="j===0">
                            <a
                              v-show="plList[y].open"
                              href="javascript:;"
                              class="flow-content-btn--showDetail"
                              @click="isOpenClose(y)"
                            >
                              更多
                              <span class="cssIcon-triangle cssIcon-triangle--t2b"></span>
                            </a>
                            <a
                              v-show="plList[y].close"
                              href="javascript:;"
                              class="flow-content-btn--hideDetail"
                              @click="isOpenClose(y)"
                            >
                              收起
                              <span class="cssIcon-triangle cssIcon-triangle--b2t"></span>
                            </a>
                            <span>{{xy.moment(i.AddCommentTime).format('MM.DD HH:mm')}}</span>
                          </span>
                          <span class="flow-content-time openOrback" v-else>
                            <span>{{xy.moment(i.AddCommentTime).format('MM.DD HH:mm')}}</span>
                          </span>
                        </div>
                        <div class="flow-content-body">
                          <p class="flow-content-reason">{{i.Comment}}</p>
                          <div class="fileList">
                            <div class="content" v-for="(a, b) in i.FileList" :key="b">
                              <div>
                                <i class="iconfont iconimg" v-if="a.FileType === 'SVG' || a.FileType === 'svg' || a.FileType === 'BMP' || a.FileType === 'JPG' || a.FileType === 'JPEG' || a.FileType === 'PNG' || a.FileType === 'GIF' || a.FileType === 'bmp' || a.FileType === 'jpg' || a.FileType === 'jpeg' || a.FileType === 'png' || a.FileType === 'gif'">&#xe705;</i>
                                <i class="iconfont icontext" v-else>&#xe706;</i>
                                {{a.type}}
                              </div>
                              <div class="fileL">
                                <div class="fileName">
                                  {{a.FileName}}
                                </div>
                                <div class="fileSize">
                      {{a.FileLength / 1024 / 1024>=1?(a.FileLength / 1024 / 1024).toFixed(2)+'MB':(a.FileLength / 1024).toFixed(2)+'KB'}}
                                </div>
                              </div>
                              <div class="fileR">
                                <!-- <van-button plain round size='small' type="info" @click="downLoad(a)">下载</van-button> -->
                                <button class="downBtn" @click="downLoad(a)">下载</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- 结束审批 -->
            <li class="flow-li" v-if="list && list.DocumentInfo && list.DocumentInfo.DocumentStatus === 4">
              <div class="launch">
                <div class="flow-item-line"></div>
                <div class="flow-li-head">
                    <span v-if="info.CreateIcon === ''">
                      {{showName(info.CreatedByName)}}
                    </span>
                    <img class="user-img" v-else :src="info.CreateIcon + '?time =' + new Date().getTime()" alt="">
                    <img class="false_img" :src="trueImgUrl" alt="">
                </div>
                <div class="flow-li-content">
                  <div class="flow-content-head">
                    <div class="flow-content-name">
                      <span>{{list.DocumentInfo.CreatedByName}}</span>
                      <span>(流程结束)</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <AddPep :isShowPep="isShowPep" @listenToChildChoice="getPepList" @listenToChildClose="closeAddPep" />
      <AllPep :isShowAll='isShowAll' :allPepList='allPepList' @listenToChildClose="closeAllPep" />
      <Reply :isShowReply="isShowReply" :list='list' @listenToChildClose="closeReply"/>
      <div class="btn-foot" v-if="info && info.DocumentStatus !== 16">
        <van-button style="flex-grow: 1" round type="info" @click="signIn" v-if="list.HasSignBtn">签收</van-button>
        <van-button round plain  type="info" v-if="list.HasAddCirculationBtn" @click="addPepBtn">添加流转</van-button>
        <van-button round plain  type="info" v-if="list.HasApplyEndBtn" @click="endApplication">申请结束</van-button>
        <van-button round plain  type="info" v-if="list.HasReviewApplyEndBtn" @click="applyEnd">结束审批</van-button>
        <van-button round type="info" v-if="list.HasAddCommentBtn" @click="addReplyBtn">添加批复</van-button>
        <van-button round plain type="info" v-if="!list.HasSignBtn && info && info.DocumentStatus !== 4  && creID === userID"  @click="retract">撤销</van-button>
      </div>
      <van-dialog 
        v-model="showIIIII" 
        close-on-click-overlay 
        show-cancel-button message= '您同意该申请吗？' 
        confirm-button-text= '同意' 
        cancel-button-text= '拒绝' 
        close-on-popstate
        @confirm= confirm
        @cancel= cancel
        >
        
      </van-dialog>
  </div>
</template>
<script>
import AddPep from './AddPep'
import Reply from './Reply'
import AllPep from './AllPep'
import { Dialog } from 'vant'
const falImgUrl = require("@/assets/operationalAnalysis/false_s.png");
const trueImgUrl = require("@/assets/operationalAnalysis/true_s.png");
const fileImgUrl = require("@/assets/operationalAnalysis/file_s.png");
const imgImgUrl = require("@/assets/operationalAnalysis/img_s.png");
export default {
  name:'Details',
  components:{
    AddPep,
    Reply,
    AllPep
  },
  data(){
    return{
      showIIIII: false,
      imgImgUrl: imgImgUrl,
      fileImgUrl: fileImgUrl,
      falImgUrl: falImgUrl,
      trueImgUrl: trueImgUrl,
      isView:true,
      filesMaxNumKB: 0,
      filesMaxNumMB: 0,
      filesMaxNumKBFixed: 0,
      filesMaxNumMBFixed: 0,
      list: [],
      info: {},
      fileList: [],
      nodeList: [],
      isOpen: false,
      isClose: false,
      displayNum: 5,
      isOpen2: false,
      isClose2: false,
      commentNum: 0,
      docID: 0,
      creID: 0,
      isShowPep: false,
      isShowReply: false,
      isShowAll: false,
      allPepList: [],
      plList: [],
      mainUrl: this.xyMApi + '/base',
      userID: this.$store.state.common.userInfo.UserID,
      apiPath: `${this.xyMApi}/oa`
    }
  },
  mounted(){
    // console.log(this.xyMApi)
    // console.log(this.$store.state.common.userInfo)
      this.$nextTick(function () {
        this.getList()
      })
  },
  inject: ['reload'],
  methods:{
    retract () {
       Dialog.confirm({
        message: '您确定要撤销该公文吗？',
      })
        .then(async () => {
          this.xy.loading()
          let res = await this.xyapi.get(`${this.apiPath}/api/DocCirculation/RevokeEnd?DocumentID=${this.$route.query.docID}`, null)
          if (res.success) {
            this.xy.msgSuc(res.msg || '撤销成功')
            var _ = this
            setTimeout(() => {
              _.getList()
            },500)
          } else {
            this.xy.msgError(res.msg || '撤销失败')
          }
          this.xy.unloading()
        })
    },
    close(){
      this.$router.go(-1)
    },
    // 详情数据
    async getList(){
      this.xy.loading()
      let res = await this.xyapi.get(`${this.apiPath}/api/DocCirculation/GetSendByMeDetail`, {
        DocumentID: this.$route.query.docID
      });
        this.xy.unloading()
      if (res.success) {
        this.list = res.data
        // console.log(this.list)
        this.info = res.data.DocumentInfo
        this.nodeList = res.data.NodeList
        this.fileList = res.data.DocumentInfo.DocFileList
        this.creID = this.list.DocumentInfo.CreatedByID
        this.docID = this.$route.query.docID
        this.$router.push({ path: '', query: { docID: this.$route.query.docID, creID: res.data.DocumentInfo.CreatedByID } })
      } else {
        this.xy.msgError(res.msg)
      }
      // 几人已签收
      if(this.nodeList.length !== 0){
        for (let i = 0; i < this.nodeList.length; i++) {
          let isClose = false
          let isOpen = false
          let commentNum = 0
          if (this.nodeList[i].CommentList.length > 2) {
            isClose = false
            isOpen = true
            commentNum = 2
            this.plList.push({
              id: i,
              close: isClose,
              open: isOpen,
              num: commentNum
            })
          } else {
            isClose = false
            isOpen = false
            commentNum = this.nodeList[i].CommentList.length
            this.plList.push({
              id: i,
              close: isClose,
              open: isOpen,
              num: commentNum
            })
          }
        }
      }
    },
    // 审批流列表：若无图标，展示文字
    showName (name) {
      if (name) {
        // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
        if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
          return name.length > 2 ? name.slice(-2) : name
        } else if (/^[A-Za-z]+$/g.test(name)) {
          // 纯英文名只展示两个字母
          return name.slice(0, 2)
        } else {
          // 其他
          return name.slice(0, 2)
        }
      }
    },
    // 查看全部
    moreUser (list) {
      this.isShowAll = true
      this.allPepList = list
      // console.log(this.allPepList)
    },
    closeAllPep(val){
      this.isShowAll = val
    },
    // 展开或
    isOpenClose (id) {
      if (this.plList[id].open) {
        this.plList[id].close = true
        this.plList[id].open = false
        this.plList[id].num = this.nodeList[id].CommentList.length
      } else {
        this.plList[id].close = false
        this.plList[id].open = true
        this.plList[id].num = 2
      }
    },
    // 签收
    async signIn () {
      this.xy.loading()
      let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/Sign`, {
        DocumentID: this.docID,
        CreatedByID: this.creID,
        Title: this.list.DocumentInfo.Title
      });
      if (res.success) {
        this.xy.msgSuc('签收成功')
        var _ = this
        setTimeout(() => {
          _.reload()
        },500)
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    // 添加流转
    addPepBtn() {
      this.isShowPep=true
    },
    async getPepList(list){
      this.xy.loading()
      this.isShowPep=false
      let pepList = []
      list.map(item => {
        pepList.push(item.UserID)
      })
      console.log(this.creID)
      let option = {
        DocumentID: this.docID,
        CreatedByID: this.creID,
        AddUserList: pepList,
        Title: this.list.DocumentInfo.Title
      }
      let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/AddSendTo`, option, true)
      if (res.success) {
        this.xy.msgSuc('添加流转成功')
        var _ = this
        setTimeout(() => {
          _.reload()
        },500)
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    closeAddPep(val){
      this.isShowPep=val
    },
    // 添加批复
    addReplyBtn() {
      this.isShowReply = true
    },
    closeReply(val){
      this.isShowReply=val
    },
    // 申请结束
    endApplication() {
      Dialog.confirm({
        message: '您确定申请流程完成吗？',
      })
        .then(async () => {
          this.xy.loading()
          let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/ApplyEnd`, {
            DocumentID: this.docID,
            CreatedByID: this.creID,
            Title: this.list.DocumentInfo.Title
          })
          if (res.success) {
            this.xy.msgSuc('申请流程完成成功')
            var _ = this
            setTimeout(() => {
              _.reload()
            },500)
          } else {
            this.xy.msgError(res.msg)
          }
          this.xy.unloading()
        })
    },
    // 审批结束
    applyEnd() {
      this.showIIIII = true
    },
    async confirm() {
      this.xy.loading()
      let status = 2
      let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/ReviewApplyEnd`, {
        DocumentID: this.docID,
        Status: status,
        Title: this.list.DocumentInfo.Title
      })
      if (res.success) {
        this.xy.msgSuc('同意申请')
        var _ = this
        setTimeout(() => {
          _.reload()
        },500)
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    async cancel() {
      this.xy.loading()
      let status = 4
      let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/ReviewApplyEnd`, {
        DocumentID: this.docID,
        Status: status,
        Title: this.list.DocumentInfo.Title
      })
      if (res.success) {
        this.xy.msgSuc('拒绝申请')
        var _ = this
        setTimeout(() => {
          _.reload()
        },500)
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    // 下载
    downLoad (file) {
      let path = file.FilePath.match(/\/([^/]*)$/)[1]
      console.log(file)
      this.xy.downFile(`${this.apiPath}/api/DocCirculation/DownLoadFile`, {
        file: path,
        uploadFileName: file.FileName
      })
    }
  }
}
</script>
<style lang="less" scoped>
.details-wrap{
    /deep/ .comm-title {
      > span:nth-of-type(1) {
        display: inline-block;
        padding: 2px 10px;
        font-size: 24px;
        border-radius: 24px;
        color: #fff;
        margin-right: 6px;
      }
    }
    /deep/ .pt {
      > span:nth-of-type(1) {
        background: #25c40b;
      }
    }
    /deep/ .jj {
      > span:nth-of-type(1) {
        background: #f5222d;
      }
    }
}
.all-title{
  color: #333;
  font-size: 32px;
}
img{
  width: 35px;
  height: 42px;
}
i{
  font-size: 35px;
}
.icontext{
  color:#4196FF;
}
.iconimg{
  color:#F1C64E;
}
.user-img{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  vertical-align: top;
}
.btn-foot{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: space-around;
  background: #ffffff;
  height: 120px;
  align-items: center;
  padding: 16px 20px;
  button{
    flex: 1;
    margin: 0 9px;
    span{
      font-size: 30px;
    }
  }
}
.details-wrap{
  margin-top: 3px;
  background: #fff;
  padding-left: 48px;
  .fileList{
    .content{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 33px;
      padding-right: 29px;
      .file_img{
        width: 35px;
        height: 42px;
      }
      .fileL{
        width: 391px;
        margin: 0 80px 0 36px;
        color: #000;
        .fileName{
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size: 30px;
          margin-bottom: 10px;
        }
        .fileSize{
          font-size: 26px;
          color: rgba(0, 0, 0, .45);
          line-height: 26px;
        }
      }
    }
  }
  .details{
    height: 100%;
    .details-head{
      .head-ds {
        display: flex;
        align-items: center;
      }
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 46px 0 40px;
      .details-head-left{
        width: 92px;
        height: 92px;
        border-radius: 50%;
        background: #2980fe;
        text-align: center;
        line-height: 92px;
        font-size: 32px;
        color: #fff;
        font-weight: bold;
        img{
          width: 92px;
          height: 92px;
          border-radius: 50%;
        }
      }
      .details-head-right{
        margin-left: 24px;
        .details-title{
          color: #111;
          font-size: 34px;
          font-weight: bold;
          line-height: 52px;
        }
        .details-state{
          color: #606060;
          font-size: 28px;
          font-weight: 400;
          margin-top: 3px;
        }
      }
      .details-head-img {
        padding-right: 20px;
        img {
          width: 200px;
          height: 200px;
        }
      }
    }
    .details-main{
        font-size: 30px;
        font-weight: 400;
        padding-bottom: 53px;
      .info-item{
        margin-top: 50px;
        display: flex;
        .content{
          word-wrap: break-word;
          word-break: normal;
          width: 73vw;
          color: #161616;
        }
      }
      .info-item:nth-last-child(1){
        display: block;
        .content{
          width: 100%;
        }
        .fileR{
          font-size: 28px;
          .downBtn{
            border: none;
            background: #fff;
            width: 120px;
            height: 60px;
            border: 1px solid #267dff;
            border-radius: 30px;
            color:  #267dff;
            line-height: 48px;
          }
        }
      }
      .title{
        color: #606060;
        width: 20vw;
        display: inline-block;
        flex-basis: 20vw;
        flex-shrink: 0;
        font-size: 30px;
      }
    }
  }
  .document-flow{
    padding-bottom: 200px;
    .flow-title{
      font-size: 28px;
      font-weight: 400;
      line-height: 114px;
    }
    .flow-li{
      position: relative;
      .flow-item-line{
        width: 4px;
        height: 100%;
        background: #e5e3df;
        position: absolute;
        left: 28px;
        top: 12px;
      }
      .flow-li-spot{
        width:30px;
        height:30px;
        background:rgba(213,213,213,1);
        border:4px solid rgba(255,255,255,1);
        border-radius:50%;
        position: absolute;
        left: 15px;
        top: 12px;
        z-index: 1;
      }
      .flow-li-head{
        width: 44px;
        height: 44px;
        border:4px solid rgba(255,255,255,1);
        position: absolute;
        background: #2980fe;
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-size: 21px;  
        margin: 0 8px;
        z-index: 1;
        .false_img{
          position: absolute;
          bottom: 0;
          right: 0;
          transform: translate(25%, 25%);
          width: 4vw;
          height: 4vw;
        }
      }
      .flow-li-content{
        position: relative;
        padding: 0 29px 0 80px;
        .allpep{
          font-size: 30px;
          color: rgba(0, 0, 0, .85);
          margin-right: 47px;
        }
        .signpep{
          color: #2980FE;
          font-size: 28px;
          font-weight: 400;
        }
        .flow-content-time{
          color: #999;
          font-size: 24px;
          font-weight: 400;
        }
        .flow-content-head{
          margin-bottom: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .flow-content-body{
          color: #000;
          font-size: 26px;
          line-height: 44px;
          padding-bottom: 40px;
          word-wrap: break-word;
          word-break: normal;
        }
      }
      .launch{
        .flow-li-head{
          width: 60px;
          height: 60px;
          line-height: 52px;
          margin: 0;
        }
        .flow-content-name{
          font-size: 30px;
          color: #000;
          .refuse{
            display: block;
          }
        }
      }
      .maincirculation {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 80vw;
        .flow-avatar3 {
          width:50px;
          height:50px;
          font-size:18px;
          font-family:PingFang SC;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:13px;
          background: #4196ff;
          border-radius: 50%;
          text-align: center;
          position: relative;
          .false_img{
            position: absolute;
            top: 0;
            right: 0;
            width: 3.38vw;
            height: 3.38vw;
            transform: translate(25%, -25%);
          }
          span{
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            line-height: 50px;
          }
        }
      }
      .circulation {
        display: inline-block;
        width: 13vw;
        margin-top: 20px;
      }
      .circulationName {
        font-size: 2.8vw;
        color: rgba(0, 0, 0, .45);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        margin-top: 23px;
        max-width: 13vw;
      }
      .dtdd {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
.circulation-wrap{
  position: relative;
  .flow-li-content{
    padding: 0 29px 40px 80px !important;
  }
}
.plList{
  .openOrback {
    display: flex;
    flex-direction: column;
    align-content: center;
    a{
      color: #2980FE;
      font-size: 26px;
      font-weight: 400;
      text-align: right;
      margin-bottom: 12px;
    }
  }
  .flow-content-reason{
    font-size: 24px;
    line-height: 39px;
    color: rgba(0, 0, 0, .65);
  }
  .flow-content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  .flow-li-content:first-child .flow-content-header{
    margin-bottom: 13px;
  }
  .fileList{
    width: 590px;
    .content{
      padding: 0;
    }
    .fileL{
      width: 320px !important;
      .fileName{
        font-size: 28px !important;
      }
      .fileSize{
        font-size: 24px !important;
      }
    }
    .fileR{
      .downBtn{
        border: none;
        background: #fff;
        width: 110px;
        height: 50px;
        border: 1px solid #267dff;
        border-radius: 25px;
        color:  #267dff;
        line-height: 48px;
        font-size: 26px;
      }
    }
  }
}
</style>
